<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <loader v-if="loading"/>
    <b-row>

      <b-col :md="columnWith" v-for="(input, key) in fields" :key="key">
        <label :for="input.name">{{input.label}}<span class="text-danger">{{$t('form.required_star')}}</span></label>
        <div class="mb-4">
          <b-form-input
            v-model="params[input.name]"
            :placeholder="input.placeholder"
            :name="input.name"
            :id="input.name"
            @input="value => {createParamsObject(input.name, value)}"
          />
          <span class="text-danger position-absolute error"
                v-if="!$v[input.name].required && $v[input.name].$dirty">
            {{$t('form.required_field')}}
          </span>
        </div>
      </b-col>

    </b-row>

    <b-row>
      <b-col>
        <b-row>
          <b-col xl="6">
            <span class="mb-2 d-block">{{$t('form.html')}}<span class="text-danger">{{$t('form.required_star')}}</span></span>
            <b-card body-class="p-0">
              <editor
                v-model="params.html"
                lang="html" theme="chrome" width="100%" height="600"
                @init="editorInit"
                @input="value => {params.html = value; createParamsObject('html', value)}"
              ></editor>
            </b-card>
            <span class="text-danger position-absolute error"
                  v-if="!$v.html.required && $v.html.$dirty">
            {{$t('form.required_field')}}
          </span>
          </b-col>
          <b-col xl="6">
            <span class="mb-2 d-block">{{$t('form.preview')}}</span>
            <b-card body-class="p-0">
              <iframe :srcDoc="params.html" style="height: 600px;" class="w-100"/>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <form-buttons @submit="debounceSubmit" v-if="showButtons"></form-buttons>

  </div>
</template>

<script>
  import {debounce} from 'lodash';
  import {required} from "vuelidate/lib/validators";

  export default {
    name: 'EmailView',
    middleware: 'auth',
    props: {
      fields: {
        type: Array,
        require: true
      },
      editing: {
        type: Boolean,
        default: false
      },
      columnWith: {
        type: Number,
        default: 4
      },
      userPrefillId: {
        type: String
      },
      showButtons: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        prefillParams: {},
        loading: false,
        name: '',
        subject: '',
        html: '',
        params: {
          name: '',
          subject: '',
          html: ''
        },
        paramsMutated: {},
        debounceSubmit: () => {
        }
      }
    },
    validations: {
      name: {
        required
      },
      subject: {
        required
      },
      html: {
        required
      }
    },
    created () {
      window.addEventListener("keydown", this.saveWithHotkey );
    },
    destroyed() {
      window.removeEventListener("keydown", this.saveWithHotkey );
    },
    mounted() {
      if (this.editing) {
        this.getData(`mail-templates/${this.$route.params.id}`, null, true)
          .then(({data}) => {
            this.prefillParams = data;
            this.setPrefillData(this.prefillParams);
          })
      }
      this.debounceSubmit = debounce(this.submit, 1000);
    },
    methods: {
      saveWithHotkey (e) {
        if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) && (e.key === 's' || e.key === 'S')) {
          e.preventDefault();
          this.debounceSubmit();
        }
      },
      editorInit() {
        require('brace/mode/html');
        require('brace/theme/chrome')
      },
      createParamsObject(name, value) {
        this.paramsMutated[name] = value;
      },
      setPrefillData(prefill) {
        this.params.name = prefill.name;
        this.params.subject = prefill.subject;
        this.params.html = decodeURIComponent(prefill.html);
      },
      submit() {
        this.name = this.params.name;
        this.subject = this.params.subject;
        this.html = this.params.html;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (!_.isEmpty(this.prefillParams)) {
          this.putData(`mail-templates/${this.prefillParams.id}`, this.paramsMutated)
        } else {
          this.postData('mail-templates', this.paramsMutated, '/emails')
        }
      }
    }
  }
</script>
